export { default } from "./ManageClientsModal";
